import React from 'react'
import { PropTypes } from 'prop-types'
import { DescriptionTooltip } from '@fs/zion-ui'
import { css } from '@emotion/core'

const hoverableStyle = css`
  &:hover,
  &:focus {
    text-decoration: underline;
    cursor: default;
  }
`

export default function GlossaryTooltip({ overline, description }) {
  return (
    <DescriptionTooltip
      target={<span css={hoverableStyle}>{overline}</span>}
      label={description}
      placement={['top', 'start', 'end']}
    />
  )
}

GlossaryTooltip.propTypes = {
  /** Title of the list item */
  overline: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /** Text description that is displayed in the tooltip */
  description: PropTypes.string,
}
